import { GenericObject } from "src/defs";

export const domainConstant = {
  AMERITAS_INTERNAL: "oj-ameritas.com",
  AMERITAS_ADE_EXTERNAL: "okta-ameritas.com",
  AMERITAS_EXTERNAL: "ameritas.com",
  GUARDIAN_INTERNAL: "oj-glic.com",
  GUARDIAN_EXTERNAL: "glic.com",
  HUMANA_INTERNAL: "oj-humana.com",
  HUMANA_ADE_EXTERNAL: "okta-humana.com",
  HUMANA_EXTERNAL: "humana.com",
  ELHEALTH_INTERNAL: "oj-elhealth.com",
  ELHEALTH_EXTERNAL: "elevancehealth.com",
  METLIFE_INTERNAL: "oj-metlife.com",
  METLIFE_EXTERNAL: "metlife.com",
  OVERJET_INTERNAL: "overjet.com",
  PRINCIPAL_INTERNAL: "oj-principal.com",
  PRINCIPAL_EXTERNAL: "principal.com",
  UNUM_INTERNAL: "oj-unum.com",
  UNUM_EXTERNAL: "unum.com",
  DDC_INTERNAL: "oj-ddc.com",
  DDC_EXTERNAL: "ddc.com",
  DENTAQUEST_INTERNAL: "oj-dentaquest.com",
  DENTAQUEST_EXTERNAL: "dentaquest.com",
  DDMO_INTERNAL: "oj-ddmo.com",
  DDMO_EXTERNAL: "ddmo.com",
  UCD_INTERNAL: "oj-ucd.com",
  UCD_EXTERNAL: "ucd.com",
  DDIA_INTERNAL: "oj-ddia.com",
  DDIA_EXTERNAL: "ddia.com",
  DDIL_INTERNAL: "oj-ddil.com",
  DDIL_EXTERNAL: "ddil.com",
  DDKY_INTERNAL: "oj-ddky.com",
  DDKY_EXTERNAL: "ddky.com",
  DDNJ_INTERNAL: "oj-ddnj.com",
  DDNJ_EXTERNAL: "ddnj.com",
  DDVA_INTERNAL: "oj-ddva.com",
  DDVA_EXTERNAL: "ddva.com",
  DDWI_INTERNAL: "oj-ddwi.com",
  DEMO_INTERNAL: "oj-demo.com",
  RENAISSANCE_INTERNAL: "oj-renaissance.com",
  DOMINION_INTERNAL: "oj-dominion.com",
  DOMINION_EXTERNAL: "dominion.com",
  LIBERTY_INTERNAL: "oj-liberty.com",
  LIBERTY_EXTERNAL: "liberty.com",
  HUMANA_SHADOW_INTERNAL: "oj-humana-shadow.com",
  SUNLIFE_INTERNAL: "oj-sunlife.com",
  CIGNA_INTERNAL: "oj-cigna.com",
  CIGNA_EXTERNAL: "cigna.com",
  HRI_INTERNAL: "oj-hri.com",
  HRI_EXTERNAL: "hri.com",
  AETNA_INTERNAL: "oj-aetna.com",
  AETNA_EXTERNAL: "aetna.com",
  FCL_DENTAL_INTERNAL: "oj-fcldental.com",
  FCL_DENTAL_EXTERNAL: "fcldental.com",
};

export const clientIdMappper: any = {
  glic: process.env.REACT_APP_GUARDIAN_EXTERNAL_SSO_CONFIG,
  "2": process.env.REACT_APP_GUARDIAN_EXTERNAL_SSO_CONFIG,
  overjet: process.env.REACT_APP_GUARDIAN_INTERNAL_SSO_CONFIG,
  humana: process.env.REACT_APP_HUMANA_EXTERNAL_SSO_CONFIG,
  "10": process.env.REACT_APP_HUMANA_INTERNAL_SSO_CONFIG,
  elevancehealth: process.env.REACT_APP_ELHEALTH_EXTERNAL_SSO_CONFIG,
  "21": process.env.REACT_APP_ELHEALTH_INTERNAL_SSO_CONFIG,
  ddc: process.env.REACT_APP_DDC_EXTERNAL_SSO_CONFIG,
  i0001: process.env.REACT_APP_UCD_EXTERNAL_SSO_CONFIG,
  i0012: process.env.REACT_APP_CIGNA_EXTERNAL_SSO_CONFIG,
  i0029: process.env.REACT_APP_DENTAQUEST_EXTERNAL_SSO_CONFIG,
  i0032: process.env.REACT_APP_DOMINION_EXTERNAL_SSO_CONFIG,
  i0033: process.env.REACT_APP_HUMANA_SHADOW_INTERNAL_SSO_CONFIG,
  i0034: process.env.REACT_APP_LIBERTY_INTERNAL_SSO_CONFIG,
  i0035: process.env.REACT_APP_DDIA_INTERNAL_SSO_CONFIG,
  i0036: process.env.REACT_APP_HRI_INTERNAL_SSO_CONFIG,
  i0028: process.env.REACT_APP_UNUM_EXTERNAL_SSO_CONFIG,
  i0019: process.env.REACT_APP_AETNA_EXTERNAL_SSO_CONFIG,
  i0037: process.env.REACT_APP_FCL_DENTAL_EXTERNAL_SSO_CONFIG,
};

// Used for internal uses E.g ADE;
export const identityIdMapper: GenericObject = {
  humana: process.env.REACT_APP_HUMANA_INTERNAL_SSO_CONFIG,
  elevancehealth: process.env.REACT_APP_ELHEALTH_INTERNAL_SSO_CONFIG,
  i0029: process.env.REACT_APP_DENTAQUEST_INTERNAL_SSO_CONFIG,
  glic: process.env.REACT_APP_GUARDIAN_INTERNAL_SSO_CONFIG,
  i0033: process.env.REACT_APP_HUMANA_SHADOW_INTERNAL_SSO_CONFIG,
  i0028: process.env.REACT_APP_UNUM_INTERNAL_SSO_CONFIG,
};

export const ClientAccount = {
  AMERITAS: process.env.REACT_APP_AMERITAS_CLIENT_ACCOUNT_ID || "ameritas",
  AMERITAS_BM: "i0007",
  HUMANA: process.env.REACT_APP_HUMANA_CLIENT_ACCOUNT_ID || "humana",
  HUMANA_BM: "i0010",
  ELEVANCE: "i0021",
  UNUM: "i0028",
  DDMO: "i0002",
  METLIFE: "i0014",
  CIGNA: "i0012",
  DDC: "ddc",
  DDC_BM: "i0026",
  DENTAQUEST: "dentaquest",
  RENAISSANCE: "i0031",
  DEMO: "i0999",
  UCD: "i0001",
  DDIA: "i0035",
  DDIL: "i0013",
  DDKY: "i0017",
  DDNJ: "i0006",
  DDVA: "i0009",
  DELTA_COALITION_BM: "i0004",
  PRINCIPAL: "i0018",
  DDWI: "i0030",
  DOMINION: "i0032",
  HUMANA_SHADOW_BM: "i0033",
  LIBERTY: "i0034",
  GUARDIAN: "i0003",
  HRI: "i0036",
  ELEVANCE_BCT: "i2121",
  AETNA: "i0019",
  FCL_DENTAL: "i0037",
};

export const SWITCH_ACCOUNTS: Record<string, string> = {
  [ClientAccount.AMERITAS]: "Ameritas",
  [ClientAccount.AMERITAS_BM]: "Ameritas BM",
  [ClientAccount.DDMO]: "DDMO",
  [ClientAccount.HUMANA]: "Humana",
  [ClientAccount.HUMANA_BM]: "Humana BM",
  [ClientAccount.METLIFE]: "Metlife",
  [ClientAccount.ELEVANCE]: "Elevance Health",
  [ClientAccount.UNUM]: "Unum",
  [ClientAccount.DDC]: "DDC",
  [ClientAccount.DDC_BM]: "DDC BM",
  [ClientAccount.DENTAQUEST]: "DentaQuest",
  [ClientAccount.RENAISSANCE]: "Renaissance",
  [ClientAccount.DEMO]: "Demo",
  [ClientAccount.UCD]: "UCD",
  [ClientAccount.DDIA]: "DDIA",
  [ClientAccount.DDIL]: "DDIL",
  [ClientAccount.DDKY]: "DDKY",
  [ClientAccount.DDNJ]: "DDNJ",
  [ClientAccount.DDVA]: "DDVA",
  [ClientAccount.DELTA_COALITION_BM]: "DeltaCoalition BM",
  [ClientAccount.DDWI]: "DDWI",
  [ClientAccount.LIBERTY]: "Liberty",
  [ClientAccount.PRINCIPAL]: "Principal",
  [ClientAccount.HUMANA_SHADOW_BM]: "Humana(shadow) BM",
  [ClientAccount.CIGNA]: "Cigna",
  [ClientAccount.GUARDIAN]: "Guardian",
  [ClientAccount.HRI]: "HRI",
  [ClientAccount.DOMINION]: "Dominion",
  [ClientAccount.ELEVANCE_BCT]: "Elevance Health BCT",
  [ClientAccount.AETNA]: "Aetna",
  [ClientAccount.FCL_DENTAL]: "FCL Dental",
};

// guardian has two names glic and guardian
// so we need to map both to the same client id
// InsPlatform uses guardian as the clientName in the config.yml file

export const LEGACY_BM_CLIENT_ID_MAPPING: Record<string, string> = {
  "2": "i0003",
  glic: "i0003",
  guardian: "i0003",
  ameritas: "i0007",
  humana: "i0010",
  metlife: "i0014",
  principal: "i0018",
  elevancehealth: "i0021",
  ddc: "i0026",
  unum: "i0028",
};
